import { render, staticRenderFns } from "./AdminListView.vue?vue&type=template&id=50bbdad4&scoped=true"
import script from "./AdminListView.vue?vue&type=script&lang=js"
export * from "./AdminListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50bbdad4",
  null
  
)

export default component.exports